import t from"./_baseGetTag.js";import o from"./isObject.js";var r=t,e=o;var n=function(t){if(!e(t))return!1;var o=r(t);return"[object Function]"==o||"[object GeneratorFunction]"==o||"[object AsyncFunction]"==o||"[object Proxy]"==o};export{n as default};
//# sourceMappingURL=isFunction.js.map
